import React from 'react'
import PermittedConfirmModelAction from 'support/actions/PermittedConfirmModelAction'

export default function Restore () {
  return (
    <PermittedConfirmModelAction operation='restore' label='Gendan' confirmProps={{ confirm: 'Gendan', cancel: 'Annuller' }}>
      <p>Er du sikker på du vil gendanne?</p>
    </PermittedConfirmModelAction>
  )
}
